export default {
  eventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/serasa/serasaFollowUp-form.js